@if (provider) {
  @if (hasName) {
    <div>
      {{ provider.fullName }}
      <app-copy-to-clipboard [text]="provider.fullName" />
    </div>
    <div class="small">
      <strong>NPI:</strong>
      @if (provider.id && canViewProvider) {
        <span>
          <a
            target="_blank"
            routerLink="/capture-admin/providers/{{provider.npi}}"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            >
            {{ provider.npi }}
          </a>
        </span>
      }
      @if (!provider.id || !canViewProvider) {
        <span>
          {{ provider.npi }}
        </span>
      }
      @if (canViewProvider && linkToProvider && provider.id) {
        <a target="_blank" href="/capture-admin/providers/{{ provider.npi }}">
          <fa-icon [icon]="['fas', 'external-link-alt']" size="sm" />
        </a>
      }
      <app-copy-to-clipboard [text]="provider.npi" />
      @if (linkToProvider) {
        <div class="small">
          <strong>NPI Review Status</strong>:
          @if (provider && provider.status) {
            <span>
              {{ keyedStatusOptions[provider.status]?.display }}
            </span>
          }
          @if (!provider || !provider.status) {
            <span>
              <app-blank-value-dash />
            </span>
          }
        </div>
      }
    </div>
    @if (hasSpecialtiesInfo) {
      <div class="small">
        <p>{{ provider.displaySpecialty }}</p>
      </div>
    }
  } @else {
    <div>
      <span class="label">NPI:</span>
      {{ provider.npi }}
      @if (linkToProvider && provider.id) {
        <a target="_blank" href="/capture-admin/providers/{{ provider.npi }}">
          <fa-icon [icon]="['fas', 'external-link-alt']" size="sm" />
        </a>
      }
      <app-copy-to-clipboard [text]="provider.npi" />
    </div>
  }
} @else {
  <div><app-blank-value-dash /></div>
}
